import axios from "axios";


const API_ADMIN = `${process.env.REACT_APP_API_URL}/api/admin`;
const API_GESTIONNAIRE = `${process.env.REACT_APP_API_URL}/api/gestionnaire`;


// const API_ADMIN = "http://192.168.122.63:8000/api/admin";
// const API_GESTIONNAIRE = "http://192.168.122.63:8000/api/gestionnaire";

export default class MarqueService {
  static getApiUrl(role) {
    return role === "admin" ? API_ADMIN : API_GESTIONNAIRE;
  }

  static async getMarques(role, token, societeId = null) {
    try {
      const url = `${this.getApiUrl(role)}/marques`;
      const params = societeId ? { societe_id: societeId } : {};
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });

      return response.data;
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des marques:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message ||
        "Erreur lors de la récupération des marques."
      );
    }
  }

  static async getMarqueById(role, token, id) {
    try {
      const url = `${this.getApiUrl(role)}/marques/${id}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur récupération marque:", error.response?.data || error.message);
      throw new Error(
        error.response?.data?.message || "Erreur lors de la récupération de la marque."
      );
    }
  }

  static async getClasses(role, token) {
    try {
      const url = `${this.getApiUrl(role)}/classes`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des classes :", error);
      throw error;
    }
  }

  static async getComptesComptables(role, token, societeId) {
    try {
      const url = `${this.getApiUrl(role)}/comptes-comptables/by-societe`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        params: { societe_id: societeId },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération du plan comptable :", error);
      throw error;
    }
  }

  static async addMarque(role, token, newMarque) {
    try {
      const url = `${this.getApiUrl(role)}/marques`;
      const formData = new FormData();


      formData.append("numero", newMarque.numero || "");
      if (newMarque.compte_comptable_id) {
        formData.append("compte_comptable_id", newMarque.compte_comptable_id);
      }
      if (newMarque.compte_comptable_manuel) {
        formData.append("compte_comptable", newMarque.compte_comptable_manuel);
      }

      formData.append("societe_id", newMarque.societe_id);

      formData.append("nom", newMarque.nom || "");
      formData.append(
        "zone_de_protection",
        JSON.stringify(newMarque.zone_de_protection || [])
      );
      formData.append("classes", JSON.stringify(newMarque.classes || []));
      formData.append(
        "surveillance_externe",
        newMarque.surveillance_externe ? "1" : "0"
      );

      if (newMarque.proprietaire)
        formData.append("proprietaire", newMarque.proprietaire);
      if (newMarque.descriptif)
        formData.append("descriptif", newMarque.descriptif);
      if (newMarque.numero_marque)
        formData.append("numero_marque", newMarque.numero_marque);
      if (newMarque.mandataire)
        formData.append("mandataire", newMarque.mandataire);
      if (newMarque.cabinet_surveilleur)
        formData.append("cabinet_surveilleur", newMarque.cabinet_surveilleur);
      if (newMarque.numero_dossier_surveilleur)
        formData.append(
          "numero_dossier_surveilleur",
          newMarque.numero_dossier_surveilleur
        );
      if (newMarque.date_depot)
        formData.append("date_depot", newMarque.date_depot);
      if (newMarque.date_de_publication)
        formData.append("date_de_publication", newMarque.date_de_publication);
      if (newMarque.date_de_fin_opposition)
        formData.append(
          "date_de_fin_opposition",
          newMarque.date_de_fin_opposition
        );
      if (newMarque.date_de_protection)
        formData.append("date_de_protection", newMarque.date_de_protection);
      if (newMarque.date_de_renouvellement)
        formData.append("date_de_renouvellement", newMarque.date_de_renouvellement);
      if (newMarque.etat_de_la_marque)
        formData.append("etat_de_la_marque", newMarque.etat_de_la_marque);
      if (newMarque.noms_domaine_associes)
        formData.append("noms_domaine_associes", newMarque.noms_domaine_associes);
      if (newMarque.commentaire)
        formData.append("commentaire", newMarque.commentaire);

      if (newMarque.certificat_depot_pdf instanceof File) {
        formData.append("certificat_depot_pdf", newMarque.certificat_depot_pdf);
      }
      if (newMarque.certificat_enregistrement_pdf instanceof File) {
        formData.append(
          "certificat_enregistrement_pdf",
          newMarque.certificat_enregistrement_pdf
        );
      }

      const formDataEntries = {};
      for (const [key, value] of formData.entries()) {
        formDataEntries[key] = value;
      }


      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-User-Role": role,
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.error(
        "Erreur lors de l'ajout de la marque:",
        JSON.stringify(error.response?.data || error.message, null, 2)
      );
      throw error.response?.data || error;
    }
  }

  static async updateMarque(role, token, id, updatedMarque) {
    try {
      const url = `${this.getApiUrl(role)}/marques/${id}`;
      const formData = new FormData();


      formData.append("numero", updatedMarque.numero || "");
      if (updatedMarque.compte_comptable_id) {
        formData.append("compte_comptable_id", updatedMarque.compte_comptable_id);
      }
      if (updatedMarque.compte_comptable_manuel) {
        formData.append("compte_comptable", updatedMarque.compte_comptable_manuel);
      } if (updatedMarque.societe_id !== undefined) {
        formData.append("societe_id", updatedMarque.societe_id);
      }
      formData.append("nom", updatedMarque.nom || "");
      formData.append(
        "zone_de_protection",
        JSON.stringify(updatedMarque.zone_de_protection || [])
      );
      formData.append("classes", JSON.stringify(updatedMarque.classes || []));
      formData.append(
        "surveillance_externe",
        updatedMarque.surveillance_externe ? "1" : "0"
      );

      if (updatedMarque.proprietaire)
        formData.append("proprietaire", updatedMarque.proprietaire);
      if (updatedMarque.descriptif)
        formData.append("descriptif", updatedMarque.descriptif);
      if (updatedMarque.numero_marque)
        formData.append("numero_marque", updatedMarque.numero_marque);
      if (updatedMarque.mandataire)
        formData.append("mandataire", updatedMarque.mandataire);
      if (updatedMarque.cabinet_surveilleur)
        formData.append("cabinet_surveilleur", updatedMarque.cabinet_surveilleur);
      if (updatedMarque.numero_dossier_surveilleur)
        formData.append(
          "numero_dossier_surveilleur",
          updatedMarque.numero_dossier_surveilleur
        );
      if (updatedMarque.date_depot)
        formData.append("date_depot", updatedMarque.date_depot);
      if (updatedMarque.date_de_publication)
        formData.append("date_de_publication", updatedMarque.date_de_publication);
      if (updatedMarque.date_de_fin_opposition)
        formData.append(
          "date_de_fin_opposition",
          updatedMarque.date_de_fin_opposition
        );
      if (updatedMarque.date_de_protection)
        formData.append("date_de_protection", updatedMarque.date_de_protection);
      if (updatedMarque.date_de_renouvellement)
        formData.append(
          "date_de_renouvellement",
          updatedMarque.date_de_renouvellement
        );
      if (updatedMarque.etat_de_la_marque)
        formData.append("etat_de_la_marque", updatedMarque.etat_de_la_marque);
      if (updatedMarque.noms_domaine_associes)
        formData.append(
          "noms_domaine_associes",
          updatedMarque.noms_domaine_associes
        );
      if (updatedMarque.commentaire)
        formData.append("commentaire", updatedMarque.commentaire);

      if (updatedMarque.certificat_depot_pdf instanceof File) {
        formData.append(
          "certificat_depot_pdf",
          updatedMarque.certificat_depot_pdf
        );
      }
      if (updatedMarque.certificat_enregistrement_pdf instanceof File) {
        formData.append(
          "certificat_enregistrement_pdf",
          updatedMarque.certificat_enregistrement_pdf
        );
      }

      const formDataEntries = {};
      for (const [key, value] of formData.entries()) {
        formDataEntries[key] = value;
      }

      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-User-Role": role,
          "Content-Type": "multipart/form-data",
        },
        method: "POST",
      });

      return response.data;
    } catch (error) {
      console.error(
        "Erreur lors de la modification de la marque:",
        JSON.stringify(error.response?.data || error.message, null, 2)
      );
      throw error.response?.data || error;
    }
  }

  static async deleteMarque(role, token, id) {
    try {
      const url = `${this.getApiUrl(role)}/marques/${id}`;
      const response = await axios.delete(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la suppression de la marque :", error);
      throw error;
    }
  }

  static async calculateBudget(role, token, data) {
    try {
      const url = `${this.getApiUrl(role)}/calculate-marque-budget`;
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error(
        "Erreur lors du calcul du budget :",
        error.response?.data || error.message
      );
      throw error;
    }
  }
}
